export const COMPLEXION_MAP: { [key: string]: string } = {
  // 'Complexion 1': '/game_assets/character_creation/complexion/complexion1.png',
  // 'Complexion 2': '/game_assets/character_creation/complexion/complexion2.png',
  // 'Complexion 3': '/game_assets/character_creation/complexion/complexion3.png',
  'Complexion 1': '/game_assets/character_creation/complexion/Skin1.png',
  'Complexion 2': '/game_assets/character_creation/complexion/Skin6.png',
  'Complexion 3': '/game_assets/character_creation/complexion/Skin10.png',
};

export const HAIR_MAP: { [key: string]: string } = {
  // 'Hair 1': '/game_assets/character_creation/hair/hair1.png',
  // 'Hair 2': '/game_assets/character_creation/hair/hair2.png',
  'Hair 1': '/game_assets/hair_1_bob.png',
  'Hair 2': '/game_assets/hair_2_dapper.png',
  'Hair 3': '/game_assets/character_creation/hair/Spike13.png',
};

export const OUTFIT_MAP: { [key: string]: string } = {
  'Outfit 1': '/game_assets/character_creation/outfits/PeasantBlue.png',
  'Outfit 2': '/game_assets/character_creation/outfits/PeasantDressBlue.png',
  'Outfit 3': '/game_assets/character_creation/outfits/ForesterYellow.png',
  'Outfit 4': '/game_assets/character_creation/outfits/AnglerPurple.png',
};

const cursorRootPath =
  '/game_assets/sprites/phaser_game/phaser_game_ui/cursors/';
export const DEFAULT_CURSOR_PATH = `url(${cursorRootPath}glove_pointer_64_64.png)`;
export const HOVER_CURSOR_PATH = `url(${cursorRootPath}glove_pointer_64_64-hover.png)`;
export const CURSOR_CLICK_PATH = `url(${cursorRootPath}glove_pointer_64_64-click.png)`;
export const HOVER_CURSOR_CLICK_PATH = `url(${cursorRootPath}glove_pointer_64_64-hover-click.png)`;
